export default __webpack_public_path__ + "static/media/la_capelle21.7cb98d39.jpg";